// ZETA Mirror config — regions, treatments, goals (data-driven, no hardcoding in components)

export const REGIONS = [
  {
    id: "gulus",
    label: { tr: "Gülüş ve Dişler", en: "Smile & Teeth" },
    featured: true,
    pos: { zeta: { x: 50, y: 27 }, atez: { x: 50, y: 27 } },
    treatments: [
      { id: "dijital-gulus", label: { tr: "Dijital gülüş tasarımı", en: "Digital smile design" } },
      { id: "zirkonyum", label: { tr: "Zirkonyum kaplama", en: "Zirconium crowns" } },
      { id: "implant", label: { tr: "İmplant tedavisi", en: "Implant treatment" } },
      { id: "beyazlatma", label: { tr: "Diş beyazlatma", en: "Teeth whitening" } },
      { id: "lamine", label: { tr: "Lamine veneer", en: "Laminate veneer" } },
      { id: "hollywood", label: { tr: "Hollywood smile", en: "Hollywood smile" } },
      { id: "dis-eti", label: { tr: "Diş eti estetiği", en: "Gum aesthetics" } },
      { id: "full-mouth", label: { tr: "Full mouth restorasyon", en: "Full mouth restoration" } },
    ],
  },
  {
    id: "sac",
    label: { tr: "Saç", en: "Hair" },
    pos: { zeta: { x: 50, y: 3 }, atez: { x: 50, y: 3 } },
    treatments: [
      { id: "sac-ekimi", label: { tr: "Saç ekimi", en: "Hair transplant" } },
      { id: "fue", label: { tr: "FUE saç ekimi", en: "FUE hair transplant" } },
      { id: "dhi", label: { tr: "DHI saç ekimi", en: "DHI hair transplant" } },
      { id: "sakal", label: { tr: "Sakal ekimi", en: "Beard transplant" } },
      { id: "kas-ekimi", label: { tr: "Kaş ekimi", en: "Eyebrow transplant" } },
      { id: "mezoterapi", label: { tr: "Saç mezoterapisi", en: "Hair mesotherapy" } },
    ],
  },
  {
    id: "yuz",
    label: { tr: "Yüz", en: "Face" },
    pos: { zeta: { x: 72, y: 12 }, atez: { x: 72, y: 12 } },
    treatments: [
      { id: "yuz-germe", label: { tr: "Yüz germe", en: "Facelift" } },
      { id: "dolgu", label: { tr: "Dolgu uygulamaları", en: "Filler applications" } },
      { id: "botulinum", label: { tr: "Botulinum toksin uygulamaları", en: "Botulinum toxin applications" } },
      { id: "yanak-cene", label: { tr: "Yanak ve çene şekillendirme", en: "Cheek and jaw contouring" } },
      { id: "bichectomy", label: { tr: "Bichectomy", en: "Bichectomy" } },
      { id: "medikal-bakim-yuz", label: { tr: "Medikal cilt bakımı", en: "Medical skin care" } },
    ],
  },
  {
    id: "goz",
    label: { tr: "Göz ve Göz Çevresi", en: "Eyes & Eye Area" },
    pos: { zeta: { x: 28, y: 12 }, atez: { x: 28, y: 12 } },
    treatments: [
      { id: "ust-kapak", label: { tr: "Üst göz kapağı estetiği", en: "Upper eyelid surgery" } },
      { id: "alt-kapak", label: { tr: "Alt göz kapağı estetiği", en: "Lower eyelid surgery" } },
      { id: "goz-alti", label: { tr: "Göz altı uygulamaları", en: "Under-eye treatments" } },
      { id: "kas-kaldirma", label: { tr: "Kaş kaldırma", en: "Brow lift" } },
    ],
  },
  {
    id: "burun",
    label: { tr: "Burun", en: "Nose" },
    pos: { zeta: { x: 28, y: 24 }, atez: { x: 28, y: 24 } },
    treatments: [
      { id: "rinoplasti", label: { tr: "Burun estetiği", en: "Rhinoplasty" } },
      { id: "revizyon-rinoplasti", label: { tr: "Revizyon burun estetiği", en: "Revision rhinoplasty" } },
      { id: "ameliyatsiz-burun", label: { tr: "Ameliyatsız burun şekillendirme", en: "Non-surgical nose reshaping" } },
    ],
  },
  {
    id: "cene",
    label: { tr: "Çene ve Boyun", en: "Jaw & Neck" },
    pos: { zeta: { x: 66, y: 33 }, atez: { x: 66, y: 33 } },
    treatments: [
      { id: "cene-hatti", label: { tr: "Çene hattı şekillendirme", en: "Jawline contouring" } },
      { id: "gidi", label: { tr: "Gıdı estetiği", en: "Double chin treatment" } },
      { id: "boyun-germe", label: { tr: "Boyun germe", en: "Neck lift" } },
      { id: "cene-ucu", label: { tr: "Çene ucu estetiği", en: "Chin augmentation" } },
    ],
  },
  {
    id: "gogus",
    label: { tr: "Göğüs", en: "Chest" },
    pos: { zeta: { x: 50, y: 44 }, atez: { x: 50, y: 44 } },
    treatmentsByGuide: {
      zeta: [
        { id: "meme-buyutme", label: { tr: "Meme büyütme", en: "Breast augmentation" } },
        { id: "meme-kucultme", label: { tr: "Meme küçültme", en: "Breast reduction" } },
        { id: "meme-diklestirme", label: { tr: "Meme dikleştirme", en: "Breast lift" } },
        { id: "meme-rekonstruksiyon", label: { tr: "Meme rekonstrüksiyonu", en: "Breast reconstruction" } },
      ],
      atez: [
        { id: "jinekomasti", label: { tr: "Jinekomasti tedavisi", en: "Gynecomastia treatment" } },
        { id: "gogus-sekillendirme", label: { tr: "Göğüs şekillendirme", en: "Chest contouring" } },
      ],
    },
  },
  {
    id: "karin",
    label: { tr: "Karın ve Bel", en: "Abdomen & Waist" },
    pos: { zeta: { x: 50, y: 53 }, atez: { x: 50, y: 53 } },
    treatments: [
      { id: "karin-germe", label: { tr: "Karın germe", en: "Tummy tuck" } },
      { id: "liposuction-karin", label: { tr: "Liposuction", en: "Liposuction" } },
      { id: "bel-sekillendirme", label: { tr: "Bel şekillendirme", en: "Waist contouring" } },
      { id: "annelik", label: { tr: "Annelik estetiği", en: "Mommy makeover" }, priority: "zeta" },
    ],
  },
  {
    id: "vucut",
    label: { tr: "Vücut Şekillendirme", en: "Body Contouring" },
    pos: { zeta: { x: 36, y: 56 }, atez: { x: 37, y: 56 } },
    treatments: [
      { id: "vucut-germe", label: { tr: "Vücut germe", en: "Body lift" } },
      { id: "liposuction-vucut", label: { tr: "Liposuction", en: "Liposuction" } },
      { id: "erkek-vucut", label: { tr: "Erkek vücut şekillendirme", en: "Male body contouring" }, priority: "atez" },
      { id: "bel-hatti", label: { tr: "Bel hattı şekillendirme", en: "Waistline sculpting" }, priority: "zeta" },
    ],
  },
  {
    id: "kilo",
    label: { tr: "Kilo Kontrolü ve Obezite", en: "Weight Control & Obesity" },
    pos: { zeta: { x: 64, y: 55 }, atez: { x: 64, y: 55 } },
    treatments: [
      { id: "obezite-degerlendirme", label: { tr: "Obezite cerrahisi değerlendirmesi", en: "Bariatric surgery assessment" } },
      { id: "tup-mide", label: { tr: "Tüp mide", en: "Gastric sleeve" } },
      { id: "gastrik-bypass", label: { tr: "Gastrik bypass", en: "Gastric bypass" } },
      { id: "mide-balonu", label: { tr: "Mide balonu", en: "Gastric balloon" } },
      { id: "medikal-kilo", label: { tr: "Medikal kilo kontrol programı", en: "Medical weight control programme" } },
    ],
  },
  {
    id: "kol",
    label: { tr: "Kol", en: "Arms" },
    pos: { zeta: { x: 73, y: 38 }, atez: { x: 27, y: 38 } },
    treatments: [
      { id: "kol-germe", label: { tr: "Kol germe", en: "Arm lift" } },
      { id: "liposuction-kol", label: { tr: "Liposuction", en: "Liposuction" } },
      { id: "kol-sikilastirma", label: { tr: "Cilt sıkılaştırma", en: "Skin tightening" } },
    ],
  },
  {
    id: "bacak",
    label: { tr: "Bacak", en: "Legs" },
    pos: { zeta: { x: 45, y: 76 }, atez: { x: 45, y: 76 } },
    treatments: [
      { id: "uyluk-germe", label: { tr: "Uyluk germe", en: "Thigh lift" } },
      { id: "liposuction-bacak", label: { tr: "Liposuction", en: "Liposuction" } },
      { id: "bacak-sikilastirma", label: { tr: "Cilt sıkılaştırma", en: "Skin tightening" } },
    ],
  },
  {
    id: "cilt",
    label: { tr: "Cilt", en: "Skin" },
    pos: { zeta: { x: 29, y: 40 }, atez: { x: 71, y: 40 } },
    treatments: [
      { id: "leke", label: { tr: "Leke tedavileri", en: "Pigmentation treatments" } },
      { id: "akne-izi", label: { tr: "Akne izi uygulamaları", en: "Acne scar treatments" } },
      { id: "cilt-yenileme", label: { tr: "Cilt yenileme", en: "Skin renewal" } },
      { id: "lazer", label: { tr: "Lazer uygulamaları", en: "Laser treatments" } },
      { id: "medikal-bakim-cilt", label: { tr: "Medikal cilt bakımı", en: "Medical skin care" } },
    ],
  },
  {
    id: "genital",
    label: { tr: "Genital Sağlık ve Estetik", en: "Genital Health & Aesthetics" },
    discreet: true,
    treatments: [
      { id: "kadin-saglik", label: { tr: "Kadın sağlığı ve estetiği", en: "Women's health and aesthetics" }, priority: "zeta" },
      { id: "erkek-saglik", label: { tr: "Erkek sağlığı ve estetiği", en: "Men's health and aesthetics" }, priority: "atez" },
      { id: "uroloji", label: { tr: "Üroloji danışmanlığı", en: "Urology consultation" } },
      { id: "gizli-degerlendirme", label: { tr: "Kişiye özel gizli ön değerlendirme", en: "Confidential personal pre-assessment" } },
    ],
  },
];

// treatments for a region, ordered by active guide priority (never filtered, only reordered)
export function getTreatments(region, guide) {
  const g = guide === "atez" ? "atez" : "zeta";
  if (region.treatmentsByGuide) {
    const primary = region.treatmentsByGuide[g] || [];
    const secondary = region.treatmentsByGuide[g === "zeta" ? "atez" : "zeta"] || [];
    return [...primary, ...secondary];
  }
  const list = [...(region.treatments || [])];
  list.sort((a, b) => (b.priority === g ? 1 : 0) - (a.priority === g ? 1 : 0));
  return list;
}

export const GOALS = [
  { id: "dogal", label: { tr: "Daha doğal bir görünüm", en: "A more natural look" } },
  { id: "estetik", label: { tr: "Estetik değişim", en: "Aesthetic change" } },
  { id: "saglik", label: { tr: "Sağlık problemimi çözmek", en: "Solving a health problem" } },
  { id: "yenileme", label: { tr: "Önceki tedavimi yenilemek", en: "Renewing a previous treatment" } },
  { id: "doktor-onerisi", label: { tr: "Doktor önerisi almak", en: "Getting a doctor's opinion" } },
  { id: "emin-degilim", label: { tr: "Henüz emin değilim", en: "Not sure yet" } },
];

export const COUNTRIES = ["Almanya", "İsviçre", "Suudi Arabistan", "İsveç", "Rusya", "Azerbaycan", "Özbekistan", "Türkiye", "Diğer"];

export const LANGS = ["Türkçe", "English", "Deutsch", "العربية", "Svenska", "Русский", "Azərbaycan dili", "O'zbekcha"];

export const TRAVEL_DATES = [
  { id: "0-1", label: { tr: "0-1 ay içinde", en: "Within 0-1 month" } },
  { id: "1-3", label: { tr: "1-3 ay içinde", en: "Within 1-3 months" } },
  { id: "3-6", label: { tr: "3-6 ay içinde", en: "Within 3-6 months" } },
  { id: "arastirma", label: { tr: "Henüz araştırıyorum", en: "Still researching" } },
];

export const COMPANIONS = [
  { id: "evet", label: { tr: "Evet, refakatçim olacak", en: "Yes, I will have a companion" } },
  { id: "hayir", label: { tr: "Hayır, yalnız geleceğim", en: "No, I will come alone" } },
  { id: "belirsiz", label: { tr: "Henüz belli değil", en: "Not decided yet" } },
];
